import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
import { Loader } from "@vds/loaders";
import { Modal } from "@vds/modals";
import { Cell, Table, TableBody, TableHead, TableHeader, TableRow } from "@vds/tables";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useWindowSize } from "../../../hooks/viewportHooks";
import { breakpoints } from "../../../../styles/breakpoints";
import { fetchVisionRulesEndPoint } from "../../../../configuration";
import axiosInstance from "../../../axiosInterceptor";
import { formatTimeFrame, formatTimeToBrowserTime } from "../../../utility/Utils";
import { getcvAppDetails } from "../../../utility/cvAppUtils";
import AddExistingAlertModal from "./AddExistingAlertModal";
import ErrorTemplate from "../../errorTemplate/ErrorTemplate";
import {
  AlertGroupFrame,
  AlertNameFrameAndTimeFrame,
  CreateAlertTitle,
  GreyTextField,
  SmallText,
  ModalBaseLayout,
  ModalHeadingFrame,
  ModalContentFrame,
  InlineFlexRow,
  SeverityActionRow,
  SpanWithPadding,
  StickyButtonRow,
  SpanWithLeftMargin
} from "./stylesRoiModal";

const AddAlertModal = ({
  isModalOpen,
  closeRuleModal,
  cvApp,
  roiResponse,
  cameraId,
  onApiCall,
  cameraName,
  videoSource,
  cvappid,
  roiid,
  fovid,
  companionid,
  areaName,
  EEAppName,
  tagIds,
  fetchedRules = [],
  loading = false,
  rulesError = false,
  handleRetry
}) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  let rulesList = useSelector((state) => state.polygonRoiReducer.rulesByDeviceId) || [];
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList) || [];
  const { width: viewportWidth } = useWindowSize();
  const isSmallScreen = (viewportWidth ?? 1400) < parseInt(breakpoints.tablet);
  const headerStyle = {
    padding: isSmallScreen ? "0.75rem 0" : "2rem 0rem 2rem 0rem"
  };
  const [selectedOption, setSelectedOption] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const navigate = useNavigate();
  const [isExistingAlertModalOpen, setisExistingAlertModalOpen] = useState(false);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    if (selectedOption && selectedOption?.length > 1) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [selectedOption]);

  useEffect(() => {
    if (rulesList && Object.keys(rulesList).length && rulesList?.hasOwnProperty("error") && rulesList?.hasOwnProperty("error_description")) {
      // setError(rulesList?.error_description);
    } else {
      // setisExistingAlertModalOpen(false);
    }
  }, [rulesList]);
  const OpenExistingRuleModal = (event) => {
    setisExistingAlertModalOpen(false);
    setTimeout(() => {
      setisExistingAlertModalOpen(true);
    }, 100);
  };

  const onCreateRule = () => {
    closeRuleModal("open-create");
    // navigate("/createRule");
  };

  return (
    <>
      <Modal
        id="add-alert-modal"
        opened={isModalOpen}
        surface="light"
        width={isSmallScreen ? "calc(100vw - 32px)" : "780px"}
        fullScreenDialog={isSmallScreen}
        disableAnimation={false}
        disableOutsideClick={true}
        hideCloseButton={false}
        closeButton={
          <Box
            sx={{
              cursor: "pointer",
              position: "absolute",
              right: "25px",
              top: "25px",
              zIndex: 10
            }}
            onClick={closeRuleModal}
          >
            <Icon name="close" />
          </Box>
        }
        ariaLabel="Testing Modal"
      >
        <ModalBaseLayout>
          <ModalHeadingFrame>
            <CreateAlertTitle style={{ margin: 0, padding: 0, fontSize: isSmallScreen ? "20px" : undefined }}>Add Alert</CreateAlertTitle>
          </ModalHeadingFrame>
          <ModalContentFrame>
            <AlertNameFrameAndTimeFrame>
              <SmallText style={{ fontSize: isSmallScreen ? "13px" : undefined }}>
                The following alerts currently exist for the {cvApp} app on the site. Select an alert to apply the same settings to this region of interest or
                create a new alert if you’d like to set up a unique trigger and/or action.
              </SmallText>
            </AlertNameFrameAndTimeFrame>
            {loading && <Loader active fullscreen={false} surface="light" />}
            <>
              {!loading && fetchedRules.length > 0 && (
                <AlertGroupFrame style={isSmallScreen ? { overflowX: "auto", width: "100%" } : {}}>
                  <div style={isSmallScreen ? { minWidth: "480px" } : {}}>
                  <Table striped={false} surface="light" padding="standard">
                    <TableHead>
                      <TableHeader style={{ ...headerStyle, width: "10%" }}>Alert name</TableHeader>
                      <TableHeader style={{ ...headerStyle, width: "10%" }}>Trigger</TableHeader>
                      <TableHeader style={{ ...headerStyle, width: "10%" }}>Action</TableHeader>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(fetchedRules) &&
                        fetchedRules?.map((item, index) => (
                          <TableRow key={index}>
                            <Cell
                              style={{
                                width: "10%",
                                fontSize: "12px",
                                alignItems: "center"
                              }}
                            >
                              <input
                                type="radio"
                                data-testid="addAlertModalRoiPolygonConfig_alertNameRadioButton"
                                name="ruleGroup"
                                value={item.id}
                                checked={selectedOption === item.id}
                                onChange={handleRadioChange}
                                aria-label={`radio-${index}`}
                                style={{ marginRight: "8px" }}
                              />
                              <SpanWithLeftMargin>{item.name}</SpanWithLeftMargin>
                            </Cell>

                            <Cell style={{ width: "12%", fontSize: "12px" }}>
                              <InlineFlexRow>
                                <Icon name="reports-and-alerts" size="20px" color="#A7A7A7" />
                                <span>{item.condition}</span>
                              </InlineFlexRow>

                              <InlineFlexRow>
                                <Icon name="clock" size="20px" color="#A7A7A7" />
                                <span>
                                  {item?.timeFrame === "Always active" || item?.timeFrame?.length == ""
                                    ? "Always active"
                                    : formatTimeFrame(
                                        formatTimeToBrowserTime(item?.startTime ? item?.startTime : item?.starttime),
                                        formatTimeToBrowserTime(item?.endTime ? item?.endTime : item?.endtime),
                                        item?.timeFrame
                                      )}
                                </span>
                              </InlineFlexRow>
                            </Cell>
                            <Cell style={{ width: "20%", fontSize: "12px" }}>
                              <SeverityActionRow>
                                <GreyTextField bold size="small">
                                  Severity:
                                </GreyTextField>
                                <SpanWithPadding>
                                  {item?.severity ? item?.severity : "NA"}
                                </SpanWithPadding>
                              </SeverityActionRow>
                              <br />
                              <SeverityActionRow>
                                <GreyTextField bold size="small">
                                  Groups:
                                </GreyTextField>
                                <SpanWithPadding>
                                  {item?.contactGroup ? item?.contactGroup : "NA"}
                                </SpanWithPadding>
                              </SeverityActionRow>
                            </Cell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                  </div>
                </AlertGroupFrame>
              )}
              {!loading && rulesError && (!fetchedRules || fetchedRules.length === 0) && (
                <Box sx={{ width: "100%", height: "100%", margin: "20px 0" }}>
                  <ErrorTemplate
                    title="Failed to fetch rules"
                    description="Something went wrong when fetching rules"
                    onRefresh={handleRetry}
                    testId="add-alert-modal-template"
                  />
                </Box>
              )}
              <StickyButtonRow>
                <Button
                  size={isSmallScreen ? "small" : "large"}
                  use="primary"
                  width="100%"
                  data-testid="addAlertModalRoiPolygonConfig_addExistingAlertButton"
                  onClick={() => {
                    OpenExistingRuleModal();
                  }}
                  disabled={disableButton}
                >
                  Add Existing Alert
                </Button>
                <Button
                  size={isSmallScreen ? "small" : "large"}
                  use="secondary"
                  width="100%"
                  data-testid="addAlertModalRoiPolygonConfig_createAlertButton"
                  onClick={() => {
                    onCreateRule();
                  }}
                >
                  Create Alert
                </Button>
              </StickyButtonRow>
            </>
          </ModalContentFrame>
        </ModalBaseLayout>
      </Modal>
      {isExistingAlertModalOpen && (
        <AddExistingAlertModal
          isModalOpen={isExistingAlertModalOpen}
          closeRuleModal={closeRuleModal}
          cvApp={cvApp}
          roiResponse={roiResponse}
          cameraId={cameraId}
          cameraName={cameraName}
          videoSource={videoSource}
          cvappid={cvappid}
          roiid={roiid}
          fetchedRules={fetchedRules}
          selectedOption={selectedOption}
          expression={getcvAppDetails(cvAppList, cvappid)}
          fovid={fovid}
          companionid={companionid}
          areaName={areaName}
          EEAppName={EEAppName}
          tagIds={tagIds}
        />
      )}
    </>
  );
};

export default AddAlertModal;
